import { ContactFormData } from '@upright/common/activities/contact-forms/facade/contact-form';
import { useMainContext } from '@upright/ui/views/root/main/context';

export function useToggleContactModal() {
  const [contactModalOpen, setContactModalOpen, , setInitialValues] = useMainContext().contactModal;
  function toggleContactModal(initialValues?: Partial<ContactFormData>) {
    setContactModalOpen(!contactModalOpen);
    setInitialValues(initialValues);
  }
  return toggleContactModal;
}
